export { isConsentGivenFor } from "./presenter/is-consent-given-for";
export { PrivacyContext } from "./presenter/context";
export { PrivacyContextProvider } from "./presenter/context-provider";
export { privacyPreferencesScripts } from "./presenter/setup-scripts";
